import { API_URL } from "../../utils/contextHelpers";
import { api, buildQuery } from "./core";

/* Mantenedor de usuarios */
export const getUsuariosTabla = api("getUsuariosTabla", (credito) => `${API_URL}mantenedor/usuarios/tabla?credito=${credito}`);

export const getZonasUsuario = api("getZonasUsuario", (id) => `${API_URL}mantenedor/usuarios/zonas?id=${id}`);

export const getEditarUsuario = api("getEditarUsuario", (id) => `${API_URL}mantenedor/usuarios/editar?id=${id}`);

export const getEliminarUsuario = api("getEliminarUsuario", (id) => `${API_URL}mantenedor/usuarios/eliminar?id=${id}`);

export const actualizarZonaUsuario = api("actualizarZonaUsuario", (id, accion, codigo) => `${API_URL}mantenedor/usuarios/actualizar/zona?accion=${accion}&codigo=${codigo}&id=${id}`);

export const getAgregarUsuario = api("getAgregarUsuario", () => `${API_URL}mantenedor/usuarios/agregar`);

export const grabarUsuario = api("grabarUsuario", (data) => `${API_URL}mantenedor/usuarios/grabar?${buildQuery({
      id: data?.id,
      codigo: data?.codigo, 
      nombre: data?.nombre,
      usuario: data?.usuario,
      contrasena: data?.contrasena,
      email: data?.email,
      telefono: data?.telefono,
      perfil: "9", //SOLO B2C
      almacen: data?.almacen,
      canal: "S5", //SOLO B2C
      recibeEmail: data?.recibeEmail,
      activo: data?.activo,
      alter: data?.alter ? "true" : undefined,
})}`, { method: "POST" });

/* OBRA */
export const getObrasTabla = api("getObrasTabla", (codigo) => `${API_URL}mantenedor/obras/tabla?codigo=${codigo}`);

export const getEliminarObra = api("getEliminarObra", (id) => `${API_URL}mantenedor/obras/eliminar?id=${id}`);

export const getGrabarObra = api("getGrabarObra", (data) => `${API_URL}mantenedor/obras/grabar?${buildQuery({
      id: data?.id,
      codigo: data?.codigo,
      descripcion: data?.descripcion,
})}`, { method: "POST" });

/* VALIDEZ */
export const getValidezTabla = api("getValidezTabla", () => `${API_URL}mantenedor/validez/tabla`);

export const getGrabarValidez = api("getGrabarValidez", (data) => `${API_URL}mantenedor/validez/grabar?${buildQuery({
      id: data?.id,
      descripcion: data?.descripcion,
})}`, { method: "POST" });

export const getEliminarValidez = api("getEliminarValidez", (id) => `${API_URL}mantenedor/validez/eliminar?id=${id}`);

/* Despacho */
export const getComunas = api("getComunas", () => `${API_URL}comunas`);

export const getCiudad = api("getCiudad", (comuna) => `${API_URL}ciudad?comuna=${encodeURIComponent(String(comuna || "").trim())}`);



/* ALMACENES / SUCURSALES */
export const editarSucursal = api(
  "editarSucursal",
  (almacen, descripcion, nombre) =>
    `${API_URL}almacenes/editar?almacen=${encodeURIComponent(
      almacen
    )}&descripcion=${encodeURIComponent(descripcion)}&nombre=${encodeURIComponent(
      nombre
    )}`
);

export const activarSucursal = api(
  "activarSucursal",
  (almacen) =>
    `${API_URL}almacenes/activar?almacen=${encodeURIComponent(almacen)}`
);

export const desactivarSucursal = api(
  "desactivarSucursal",
  (almacen) =>
    `${API_URL}almacenes/desactivar?almacen=${encodeURIComponent(almacen)}`
);

export const getSucursales = api("getSucursal", () => `${API_URL}almacenes/sucursales`);

